import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {LinkGroupService} from '../../../shared/link/link-group.service';
import {Subject} from 'rxjs';
import {Modal} from '@common/core/ui/dialogs/modal.service';
import {LinkStats} from '../../../shared/link/link.service';
import {LinkGroup} from '../../../shared/link/link-group';
import {SKELETON_ANIMATIONS} from '@common/core/ui/skeleton/skeleton-animations';
import { BiolinksService } from '../../biolinks/biolinks.service';

@Component({
    selector: 'link-group-analytics-page',
    templateUrl: './link-group-analytics-page.component.html',
    styleUrls: ['./link-group-analytics-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: SKELETON_ANIMATIONS,
})
export class LinkGroupAnalyticsPageComponent implements OnInit {
    public analytics$ = new Subject<LinkStats>();
    public linkGroup$ = new Subject<LinkGroup>();
    public analyticsEndpoint: string;

    constructor(
        public route: ActivatedRoute,
        private modal: Modal,
        private groups: LinkGroupService,
        private biolinks: BiolinksService,
    ) {}

    ngOnInit() {
        this.route.params.subscribe(params => {
            const linkeableId = params.groupId || params.biolinkId;
            const api = params.groupId ? this.groups : this.biolinks;
            this.analyticsEndpoint = api.analyticsEndpoint(linkeableId);
            (api.analytics(linkeableId) as any).subscribe(response => {
                this.analytics$.next(response.analytics);
                this.linkGroup$.next(response.linkGroup || response.biolink);
            });
        });
    }
}
